module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAKBJREFUSA3tk2EKgDAIhXeJOkP3p27QEbpLP8uPGAxp6WDVHwULfU/fdCylsNjAHxtYRHQVHwxxcHjwm43CQ3wTrwmRB4cHv9nKBndCFu4WrDWq5d2NNVE3nISQV3Q3oa53x6XQLlXWXbkbayITZAH+xF3t9UlKAe6g+51oAWKslr/Qhq/VyMJdUp+8+EWOghAnfrJRQHjzEymw2MA7GzgBzQw/fLPYL9kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./styles/images/close_hover.png
// module id = 839
// module chunks = 1